import { useState, useEffect, useCallback } from 'react';
import { cardApi } from '../api/client';
import { PER_PAGE } from '../utils/constants';

export function useCards() {
  const [cards, setCards] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState('scraped_at');
  const [sortOrder, setSortOrder] = useState('desc');
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCards = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params = {
        page,
        per_page: PER_PAGE,
        sort_by: sortBy,
        sort_order: sortOrder,
        ...filters,
      };
      // Remove empty filter values
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      const response = await cardApi.list(params);
      setCards(response.data.items);
      setTotal(response.data.total);
      setPages(response.data.pages);
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to fetch cards');
    } finally {
      setLoading(false);
    }
  }, [page, sortBy, sortOrder, filters]);

  useEffect(() => {
    fetchCards();
  }, [fetchCards]);

  const toggleSort = (column) => {
    if (sortBy === column) {
      setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
    setPage(1);
  };

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
  };

  const updateCard = async (id, data) => {
    try {
      await cardApi.update(id, data);
      fetchCards();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to update card');
    }
  };

  const deleteCard = async (id) => {
    try {
      await cardApi.delete(id);
      fetchCards();
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to delete card');
    }
  };

  return {
    cards,
    total,
    pages,
    page,
    setPage,
    sortBy,
    sortOrder,
    toggleSort,
    filters,
    updateFilters,
    loading,
    error,
    refresh: fetchCards,
    updateCard,
    deleteCard,
  };
}
